import { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Collapse, Nav, NavbarBrand } from 'reactstrap';

import { getUserRoles, hasPermission, includesRole } from '../../helpers/user';
import { PLANS_STATUS } from '../../constants/subscription';

import './styles.scss';

import small_logo from '../../assets/images/Kraal-colour-white-icon.webp';
import kraalWhitelogo from '../../assets/images/Kraal-colour-white.webp';

class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.activeRoute.bind(this);

    this.state = {
      collapse: '',
      user: props.user
    };
  }

  activeRoute(routeName) {
    const { pathname } = this.props.location;

    if (
      routeName === '/maps' &&
      (pathname.match(/^\/tracking\/\d+$/) ||
        pathname.match(/^\/farm\/\d+$/) ||
        pathname.match(/^\/pasture\/\d+$/) ||
        pathname.match(/^\/site\/\d+$/))
    ) {
      return 'selected';
    }

    return pathname.indexOf(routeName) === 0 ? 'selected' : '';
  }

  onClickMenuItem(item) {
    this.setState({
      collapse: item?.name ?? false
    });
  }

  render() {
    let isDesktopView = true;
    if (document.getElementById('main-wrapper') && document.getElementById('main-wrapper').offsetWidth < 768) {
      isDesktopView = false;
    }
    const user = this.props.user;
    const roles = getUserRoles(user?.roles);
    const userSubscription = this.props.subscription;

    // if user_plan_id available - it's primary account holder, if not - it's linked user, his menu is defined by available features
    const isPlanActive = userSubscription.myPlan?.user_plan_id ? userSubscription.myPlan?.status === PLANS_STATUS.ACTIVE : true;


    return (
      <aside
        className="left-sidebar mini-sidebar"
        id="sidebarbg"
        data-sidebarbg={this.props.data.settings[0].sidebarbg}>
        {isDesktopView && (
          <NavbarBrand href="/">
            <span className="logo-icon">
              <img src={small_logo} alt="homepage" className="light-logo" width={35} />
            </span>
            <span className="logo-text">
              <img src={kraalWhitelogo} className="light-logo expendlogo" alt="homepage" width={135} />
            </span>
          </NavbarBrand>
        )}
        <div className="scroll-sidebar">
          {isPlanActive && (
            <PerfectScrollbar className="sidebar-nav">
              {/*--------------------------------------------------------------------------------*/}
              {/* Sidebar Menus will go here                                                */}
              {/*--------------------------------------------------------------------------------*/}
              <Nav id="sidebarnav">
                {this.props.routes.map((prop, key) => {
                  if (prop?.permissions && !hasPermission(prop.permissions, this.props.userPermissions)) {
                    return null;
                  }

                  if (prop?.roles?.length && !includesRole(prop?.roles, roles)) {
                    return null;
                  }
                  if (prop.redirect || prop.display === false) {
                    return null;
                  } else if (prop.navlabel) {
                    return (
                      <li className="nav-small-cap" key={key} onClick={() => this.onClickMenuItem()}>
                        <i className={prop.icon}></i>
                        <span className="hide-menu">{prop.name}</span>
                      </li>
                    );
                  } else if (prop.collapse) {
                    let firstdd = {};

                    firstdd[prop['state']] = !this.state[prop.state];
                    return (
                      /*--------------------------------------------------------------------------------*/
                      /* Menus wiil be goes here                                                        */
                      /*--------------------------------------------------------------------------------*/
                      <li className={this.activeRoute(prop.path) + ' sidebar-item'} key={key}>
                        <a
                          data-toggle="collapse"
                          className="sidebar-link has-arrow"
                          aria-expanded={this.state[prop.state]}
                          onClick={() => this.onClickMenuItem(prop)}>
                          <i className={prop.icon} />
                          <span className="hide-menu">{prop.name}</span>
                        </a>
                        {/*--------------------------------------------------------------------------------*/}
                        {/* Sub-Menus wiil be goes here                                                    */}
                        {/*--------------------------------------------------------------------------------*/}
                        <Collapse isOpen={prop.name === this.state.collapse}>
                          <ul className="first-level">
                            {prop.children.map((prop, key) => {
                              if (prop.redirect) return null;

                              if (prop.collapse) {
                                let seconddd = {};
                                seconddd[prop['state']] = !this.state[prop.state];
                                return (
                                  <li className={this.activeRoute(prop.path) + ' sidebar-item'} key={key}>
                                    <a
                                      data-toggle="collapse"
                                      className="sidebar-link has-arrow"
                                      aria-expanded={this.state[prop.state]}
                                      onClick={() => this.setState(seconddd)}>
                                      <i className={prop.icon} />
                                      <span className="hide-menu">{prop.name}</span>
                                    </a>
                                    {/*--------------------------------------------------------------------------------*/}
                                    {/* Sub-Menus wiil be goes here                                                    */}
                                    {/*--------------------------------------------------------------------------------*/}
                                    <Collapse isOpen={this.state[prop.state]}>
                                      <ul className="second-level">
                                        {prop.subchild.map((prop, key) => {
                                          if (prop.redirect) return null;
                                          return (
                                            <li
                                              className={this.activeRoute(prop.path) + ' sidebar-item'}
                                              key={key}
                                              onClick={() => this.onClickMenuItem()}>
                                              <NavLink to={prop.path} activeClassName="active" className="sidebar-link">
                                                <i className={prop.icon} />
                                                <span className="hide-menu">{prop.name}</span>
                                              </NavLink>
                                            </li>
                                          );
                                        })}
                                      </ul>
                                    </Collapse>
                                  </li>
                                );
                              }
                              return (
                                /*--------------------------------------------------------------------------------*/
                                /* Adding Sidebar Item                                                            */
                                /*--------------------------------------------------------------------------------*/
                                <li
                                  className={
                                    this.activeRoute(prop.path) + (prop.pro ? ' active active-pro' : '') + ' sidebar-item'
                                  }
                                  key={key}>
                                  <NavLink to={prop.path} className="sidebar-link" activeClassName="active">
                                    <i className={prop.icon} />
                                    <span className="hide-menu">{prop.name}</span>
                                  </NavLink>
                                </li>
                              );
                            })}
                          </ul>
                        </Collapse>
                      </li>
                    );
                  } else {
                    const hasFeature = !!prop.features.some(
                      feature => this.props.subscription.myMappedFeatureOptions?.[feature]
                    );
                    if (!hasFeature) return null;

                    return (
                      /*--------------------------------------------------------------------------------*/
                      /* Adding Sidebar Item                                                            */
                      /*--------------------------------------------------------------------------------*/
                      <li
                        className={this.activeRoute(prop.path) + (prop.pro ? ' active active-pro' : '') + ' sidebar-item'}
                        key={key}
                        onClick={() => this.onClickMenuItem()}>
                        <NavLink to={prop.path} className="sidebar-link" activeClassName="active">
                          <i className={prop.icon} />
                          <span className="hide-menu">{prop.name}</span>
                        </NavLink>
                      </li>
                    );
                  }
                })}
              </Nav>
            </PerfectScrollbar>
          )}
        </div>
      </aside>
    );
  }
}

export default connect(state => ({
  user: state?.user?.user,
  subscription: state?.subscription
}))(Sidebar);
